import { connect, ConnectedProps } from 'react-redux'

import { pageToggleOverlay } from 'redux/actions'
import AccountDetails from 'components/account/AccountDetails'
import { RootState, AppDispatch } from 'redux/store';
import { ReactElement } from 'react';

const mapStateToProps = (state: RootState) => ({
  details: state.user.details
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  pageToggleOverlay: (component: ReactElement | null) => dispatch(pageToggleOverlay(component) as any)
})

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AccountDetailsContainerProps = ConnectedProps<typeof connector>

export default connector(AccountDetails)
